import { API_BASE_URL } from "configs/AppConfig";

const getSocketConfig = () => {
	try {
		const url = new URL(API_BASE_URL);
		const isLocalDev =
			url.hostname === "localhost" || url.hostname === "127.0.0.1";
		if (isLocalDev) {
			return { origin: url.origin, path: "/socket.io" };
		}
		const basePath = url.pathname.replace(/\/api(\/v\d+)?\/?$/, "");
		return { origin: url.origin, path: `${basePath}/socket.io` };
	} catch {
		const match = API_BASE_URL.match(/^(https?:\/\/[^/]+)(\/.*)?$/);
		const origin = match ? match[1] : API_BASE_URL;
		const isLocalDev =
			origin.includes("localhost") || origin.includes("127.0.0.1");
		if (isLocalDev) {
			return { origin, path: "/socket.io" };
		}
		const fullPath = (match && match[2] ? match[2] : "").replace(/\/$/, "");
		const basePath = fullPath.replace(/\/api(\/v\d+)?$/, "");
		return { origin, path: `${basePath}/socket.io` };
	}
};

export default getSocketConfig;
